import { Dynamic } from './Dynamic';

export const FooterDynamic = () => <Dynamic componentKey="footer" />;
